

export const Router = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/homeIndex.vue')
  },
  {
    path: '/coachPlatform',
    name: 'coachPlatform',
    component: () => import('@/views/coach/platformIndex.vue')
  },
  {
    path: '/scormPlatform',
    name: 'scormPlatform',
    component: () => import('@/views/scorm/scormIndex.vue')
  },
  {
    path: '/overview',
    name: 'overview',
    component: () => import('@/views/overview/overviewIndex.vue')
  },
  {
    path: '/datahandle',
    name: 'datahandle',
    component: () => import('@/views/dataHandle/dataHandleIndex.vue')
  },
  {
    path: '/companyList',
    name: 'companyList',
    component: () => import('@/views/companyList/companyListIndex.vue')
  },
  // 课程介绍页
  {
    path: '/courseIntroduce',
    name: 'courseIntroduces',
    component: () => import('@/views/course/courseIntroduce.vue'),
    children:[]
  },
  // LMS平台在pc上跳转的中转页
  {
    path: '/scromCourse',
    name: 'scromCourse',
    component: () => import('@/views/course/scromCourse.vue'),
    children:[]
  },
  // 智能陪练scorm页面
  {
    path: '/intelligentScorm',
    name: 'intelligentScorm',
    component: () => import('@/views/course/intelligentTrain/intelligentScorm.vue'),
    children:[]
  },
  {
    path: '/course',
    name: 'course',
    // redirect: '/course/abilityTest',
    component: () => import('@/views/course/courseIndex.vue'),
    children: [
      {
        /* 能力诊断 引导页 */
        path: 'abilityTest',
        name: 'abilityTest',
        component: () => import('@/views/course/abilityTest/begin.vue'),
        meta:{
          heart_beat_moduleId: '1',
        }
      },
      {
        /* 能力答题 开始 */
        path: 'abilityAnswer',
        name: 'abilityAnswer',
        component: () => import('@/views/course/abilityTest/abilityAnswer.vue'),
        meta:{
          heart_beat_moduleId: '1',
        }
      },
      {
        /* 能力答题 报告 */
        path: 'abilityReport',
        name: 'abilityReport',
        component: () => import('@/views/course/abilityTest/abilityReport.vue'),
        meta:{
          heart_beat_moduleId: '1',
        }
      },
      /* 学习 答题页 */
      {
        path: 'practiceQuestions',
        name: 'practiceQuestions',
        component: () => import('@/views/course/study/practiceQuestions.vue'),
        meta:{
          heart_beat_moduleId: '2',
        }
      },
      /* 学习 结束单元 */
      {
        path: 'endUnit',
        name: 'endUnit',
        component: () => import('@/views/course/study/endUnit.vue'),
        meta:{
          heart_beat_moduleId: '2',
        }
      },
      /* 学习 结束学习 */
      {
        path: 'endStudy',
        name: 'endStudy',
        component: () => import('@/views/course/study/endStudy.vue'),
        meta:{
          heart_beat_moduleId: '2',
        }
      },
      /* 学习 精华笔记 */
      {
        path: 'essenceNotes',
        name: 'essenceNotes',
        component: () => import('@/views/course/study/essenceNotes.vue'),
        meta:{
          heart_beat_moduleId: '2',
        }
      },
      /* 学习 案例 */
      {
        path: 'case',
        name: 'case',
        component: () => import('@/views/course/study/case.vue'),
        meta:{
          heart_beat_moduleId: '2',
        }
      },
      /* 学习 阅读 */
      {
        path: 'read',
        name: 'read',
        component: () => import('@/views/course/study/read.vue'),
        meta:{
          heart_beat_moduleId: '2',
        }
      },
      /* 学习 视频 */
      {
        path: 'videoLearning',
        name: 'videoLearning',
        component: () => import('@/views/course/study/videoLearning.vue'),
        meta:{
          heart_beat_moduleId: '2',
        }
      },
      /* 情景模拟 列表 */
      {
        path: 'scenarioSimulation',
        name: 'scenarioSimulation',
        component: () => import('@/views/course/scenarioSimulation/scenarioSimulationIndex.vue'),
        meta:{
          heart_beat_moduleId: '3',
        }
      },
      /** 情景模拟1029 新地址 */
      {
        path: 'scenarioSimulationNew',
        name: 'scenarioSimulation',
        component: () => import('@/views/course/scenarioSimulation/sceneSimulationContentNew.vue'),
        meta:{
          heart_beat_moduleId: '3',
        }
      },
      /* 情景模拟 行为分析 */
      {
        path: 'keyBehaviorAnalysis',
        name: 'keyBehaviorAnalysis',
        component: () => import('@/views/course/scenarioSimulation/keyBehaviorAnalysis.vue'),
        meta:{
          heart_beat_moduleId: '3',
        }
      },
      /* 情景模拟 内容学习/能力考核 */
      {
        path: 'sceneSimulationContent',
        name: 'sceneSimulationContent',
        component: () => import('@/views/course/scenarioSimulation/sceneSimulationContent.vue'),
        meta:{
          heart_beat_moduleId: '3',
        }
      },
      {
        /* 能力考核 开始 */
        path: 'checkTest',
        name: 'checkTest',
        component: () => import('@/views/course/abilityCheck/begin.vue'),
        meta:{
          heart_beat_moduleId: '4',
        }
      },
      {
        /* 能力考核 答题 */
        path: 'checkAnswer',
        name: 'checkAnswer',
        component: () => import('@/views/course/abilityCheck/checkAnswer.vue'),
        meta:{
          heart_beat_moduleId: '4',
        }
      },
      {
        /* 能力考核 报告 */
        path: 'checkReport',
        name: 'checkReport',
        component: () => import('@/views/course/abilityCheck/checkReport.vue'),
        meta:{
          heart_beat_moduleId: '4',
        }
      },
      {
        /* 作业页面 */
        path: 'exerciseIndex',
        name: 'exerciseIndex',
        component: () => import('@/views/course/exercise/exercise-index.vue')
      }
    ]
  },
  {
    path: '/leadershipDNA',
    name: 'leadershipDNA',
    // redirect: '/leadershipDNA/evaluationIntroduction',
    component: () => import('@/views/leadershipDNA/leadershipDNAIndex.vue'),
    // children: [
    //   /* 领导力DNA 引导页 */
    //   {
    //     path: 'evaluationIntroduction',
    //     name: 'evaluationIntroduction',
    //     component: () => import('@/views/leadershipDNA/evaluationIntroduction.vue')
    //   },
    //   /* 领导力DNA 答题页 */
    //   {
    //     path: 'answer',
    //     name: 'answer',
    //     component: () => import('@/views/leadershipDNA/answer.vue')
    //   },
    //   /* 领导力DNA 报告 */
    //   {
    //     path: 'evaluationReport',
    //     name: 'evaluationReport',
    //     component: () => import('@/views/leadershipDNA/evaluationReport.vue')
    //   },
    //   /* 领导力DNA 详情 */
    //   {
    //     path: 'evaluationReportAnalyze',
    //     name: 'evaluationReportAnalyze',
    //     component: () => import('@/views/leadershipDNA/evaluationReportAnalyze.vue')
    //   },
    //
    //
    //
    // ]
  },
  {
    path: '/projectCourseList',
    name: 'projectCourseList',
    // redirect: '/course/abilityTest',
    component: () => import('@/views/project/projectCourseIndex'),
    children:[]
  },
  {
    path: '/campList',
    name: 'campList',
    component: () => import('@/views/camp/camp-index'),
    children:[]
  },
  {
    path: '/campCouse',
    name: 'campCouse',
    component: () => import('@/views/camp/camp-course/camp-course-index.vue'),
    children:[]
  },
  {
    path: '/applicationToolTips',
    name: 'applicationTool',
    component: () => import('@/views/applicationTool/module/applicationToolTips.vue'),
  },
  // 应用工具
  {
    path: '/applicationTool',
    name: 'applicationTool',
    redirect: '/applicationToolHome',
    component: () => import('@/views/applicationTool/index.vue'),
    children: [
      /* 领导力DNA 引导页 */
      {
        path: '/applicationToolHome',
        name: 'applicationTool',
        redirect: '/toolMagazine',
        component: () => import('@/views/applicationTool/module/applicationToolHome.vue'),
        children: [
          {
            path: '/applicationTool',
            name: 'toolMagazine',
            component: () => import('@/views/applicationTool/module/toolMagazine/index.vue'),
          },
          {
            path: '/applicationTool',
            name: 'myApplication',
            component: () => import('@/views/applicationTool/module/myApplication/index.vue'),
          },
        ]
      },
      {
        path: '/coach',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/coach/index.vue'),
      },
      {
        path: '/authorization',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/authorization/index.vue'),
      },
      {
        path: '/performance',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/performance/index.vue'),
      },
      {
        path: '/performancePlan',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/performancePlan/index.vue'),
      },
      {
        path: '/communication',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/communication/index.vue'),
      },
      {
        path: '/planningOrganizationDailyTask',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/planningOrganization/dailyTask/index.vue'),
      },
      {
        path: '/planningOrganizationLargeProject',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/planningOrganization/largeProject/index.vue'),
      },
      {
        path: '/startMakeDecision',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/makeDecision/startMakeDecision/index.vue'),
      },
      {
        path: '/communicateMakeDecision',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/makeDecision/communicateMakeDecision/index.vue'),
      },
      {
        path: '/influenceDefault',
        name: 'applicationTool',
        component: () => import('@/views/applicationTool/module/influenceDefault/index.vue'),
      },
    ]
  }
]
export default Router





// WEBPACK FOOTER //
// ./src/router/business.router.js